<template>
  <div class="c-storage-deadline-modal">
    <!--
    <b-button v-b-modal.storage-deadline-modal>
      Launch modal
    </b-button>
    -->

    <b-modal
      id="storage-deadline-modal"
      ref="modal"
      size="lg"
      hide-header
      hide-footer
    >
      <div class="py-3">
        <StorageDeadlineNotice
          @continue-clicked="handleContinueClicked"
        />
      </div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import StorageDeadlineNotice from "@/UI/Landing/StorageDeadlineNotice.vue";
import { BModal } from "bootstrap-vue";

@Component({
  components: {StorageDeadlineNotice}
})
export default class StorageDeadlineAlert extends Vue {
  $refs!: {
    modal: BModal | any
  }

  mounted() {
    this.$bvModal.show('storage-deadline-modal');
  }

  handleContinueClicked() {
    this.$refs.modal.hide();
  }
}
</script>

<style lang="scss" scoped>
</style>
